import { render, staticRenderFns } from "./TicketMainSectionSidebar.vue?vue&type=template&id=a4b92c6c&"
import script from "./TicketMainSectionSidebar.vue?vue&type=script&lang=js&"
export * from "./TicketMainSectionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TicketMainSectionSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports